module.exports = __webpack_public_path__ + "img/page10-min-min.eb37bfbc.jpg";